import React, { Fragment, useEffect } from 'react';
import _ from 'lodash';
import { getMenuContentStackData } from 'features/registration/actions';
import styled from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { palette, darkTheme } from 'theme';
import { connect } from 'react-redux';
import Divider from '@material-ui/core/Divider';
import Badge from '@material-ui/core/Badge';
import AccountIcon from 'mdi-material-ui/AccountCircle';

import CartButton from 'views/Layout/Header/elements/CartButton';
import SearchButton from 'views/Layout/Header/elements/SearchButton';
import NavLink from 'views/Layout/Header/elements/NavLink';
import Container from 'components/Container';
import Announcements from 'views/Layout/Header/elements/Announcements';
import Dropdown from './Dropdown';

const TopBarWrapper = styled.div`
  height: 42px;
  background-color: ${palette.grey[900]};
  display: flex;
  align-items: center;
  overflow: visible;
  position: relative;
  z-index: 1300;
`;

const FlexNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  overflow: visible;
`;

const FlexSubNav = styled(FlexNav)`
  justify-content: flex-end;
  overflow: visible;
`;

const VerticalDivider = styled(Divider)`
  width: 1px;
  height: 24px;
  margin: 0 8px;
`;

const TopNavLink = styled(NavLink)`
  font-weight: 500;
`;

const TopBar = ({ stack, menuStack, user, getMenuContentStackData }) => {
  useEffect(() => {
    getMenuContentStackData();
  }, [getMenuContentStackData]);

  return (
    <TopBarWrapper>
      <MuiThemeProvider theme={darkTheme}>
        <Container>
          <FlexNav>
            <Announcements items={stack.announcements} />
            <FlexSubNav>
              {(stack.secondary || []).map((item, idx) => (
                <Fragment key={idx}>
                  {item.link_item && <TopNavLink {...item.link_item} />}
                  {item.main_item && (
                    <Dropdown
                      label={item.main_item.label}
                      groups={item.main_item.groups}
                    />
                  )}
                </Fragment>
              ))}
              <VerticalDivider />
              <SearchButton />
              {(stack.utilities || []).map((item, idx) => (
                <TopNavLink {...item} key={idx} />
              ))}
              <CartButton />
              <Dropdown
                label={
                  <Badge
                    color="error"
                    variant="dot"
                    invisible={user.loginStatus !== 'email_not_verified'}
                  >
                    <AccountIcon />
                  </Badge>
                }
                legacyGroups={_.get(menuStack.menus, [
                  user.loginStatus,
                  'group'
                ])}
                popperProps={{ placement: 'bottom-end' }}
              />
            </FlexSubNav>
          </FlexNav>
        </Container>
      </MuiThemeProvider>
    </TopBarWrapper>
  );
};

export default connect(
  state => ({
    stack: state.navigation.stack,
    menuStack: state.registration.content_stack.menu,
    user: state.buckaneer.user
  }),
  { getMenuContentStackData }
)(TopBar);
